import { camelCase } from '@cc-shopping/utils/string/camelCase';
import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

export const getDriverMinimumDepositDescription = (
  marketplaceEntity: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  if (!marketplaceEntity.driverMinimumDeposit) return null;
  return {
    id: camelCase(marketplaceEntity.driverMinimumDeposit.label),
    label: marketplaceEntity.driverMinimumDeposit.label,
    value: marketplaceEntity.driverMinimumDeposit.value,
    description: marketplaceEntity.driverMinimumDeposit.description,
    labelTooltip: undefined,
    valueTooltip: undefined,
    valueTooltipHasHtml: false,
  };
};
